// base
import { createAction } from '@reduxjs/toolkit';

// default
export const SECL = 'secl';
export const SECL_SLICE_NAME = `${SECL}Slice`;

// action
const GET_SECL_HISTORY_LIST = `${SECL}/getSeclHistoryList`;
const GET_SECL_HISTORY_LIST_VENDOR = `${SECL}/getSeclHistoryListVendor`;
const GET_SECL_LIST = `${SECL}/getSeclList`;
const CREATE_SECL = `${SECL}/createSecl`;

// createAction
const getSeclHistoryListAction = createAction(GET_SECL_HISTORY_LIST);
const getSeclHistoryListVendorAction = createAction(
  GET_SECL_HISTORY_LIST_VENDOR
);
const getSeclListAction = createAction(GET_SECL_LIST);
const createSeclAction = createAction(CREATE_SECL);

// actions
export const actions = {
  getSeclHistoryListAction: getSeclHistoryListAction,
  getSeclHistoryListVendorAction: getSeclHistoryListVendorAction,
  getSeclListAction: getSeclListAction,
  createSeclAction: createSeclAction
};
